import { render } from "./BaseLinkAsset.vue?vue&type=template&id=50f91e29&scoped=true"
import script from "./BaseLinkAsset.vue?vue&type=script&lang=js"
export * from "./BaseLinkAsset.vue?vue&type=script&lang=js"

import "./BaseLinkAsset.vue?vue&type=style&index=0&id=50f91e29&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f91e29"]])

export default __exports__